export default function () {
  return {
    userId: '',
    userType: null,
    loggedIn: false,
    password: '',
    isSsoUser: false,

    // Actions Happening Booleans
    verifyingToken: true,
    resettingPassword: false,
    updatingPassword: false,
    requestingNewToken: false,
    tokenUserMessage: '',
    previousAttemptLoginUserId: '',
    lockoutWarningCounter: 0,
    loggingIn: false,
    issuingResetPasswordInstructions: false,
    issuingNewRegistrationEmail: false,

    // User Role information
    userRole: {},
    subGroupAccess: [],
    minimumAccess: {
      claimsAllowed: false,
      createGroupUsersAllowed: false,
      enrollmentAllowed: false,
      memberMaintenanceAllowed: false,
      memberSearchAllowed: false,
      primaryContact: false,
      viewInvoicesAllowed: false,
    },

    // Errors & Notifications
    announcement: '',
    tokenError: false,
    authError: false,
    authFailed: false,
    updatePasswordErrorMessage: '',
    authStatus: '',
    authMessage: '',
    authValue: {},
    resetPasswordMessage: '',
    ssoAuthError: false,
    ssoAuthErrorMessage: '',
    termsAndConditionsAccepted: false,
    smsReminder: false,
    smsEnabled: true,
    closeSmsPrompt: false
  }
}
